<template>
    <div>

    </div>
</template>

<script>
import { ConfigrationModel } from '@model/configuration-model.js'
import { NavigationTool } from '@/utils/navigation-tool.js'
import { AccountInfoModel } from '@model/account-info-model'
import API from '@/api/index'
export default {
    computed: {
        configurationModel() {
            return this.$store.state.configurationModel
        },

        hospitalID() {
            return this.configurationModel?.model.hospitalId
        },

        hospitalName() {
            return this.configurationModel?.model.hospitalName
        },

        queryName() {
            return this.configurationModel?.model.name
        },
    },
    data() {
        return {
            taskID: undefined
        }
    },
    created() {
        this.taskID = this.$route.query.taskId
        this.getConfigurationInfo()
    },
    mounted() {

    },
    methods: {
        async getConfigurationInfo() {
            try {
                const config = await API.getConfiguration({
                    taskId: this.taskID,
                    accessType: 1,
                })
                const configurationInfo = new ConfigrationModel(config)
                this.$store.commit('saveConfigurationModel', configurationInfo)
                console.log(config);
                
                let userInfo = {}
                const loginInfo = this.$store.getters['user/getUser']
                //创建用户为否，不获取用户信息
                if (this.configurationModel.model.createUser === 1) {
                    //获取用户信息
                    const data = await API.userInfoRequest({ id: loginInfo.uid })
                    userInfo = {
                        "truename": data.trueName,
                        "birthday": data.birthday,
                        "sex": data.sex == 2 ? '女' : '男',
                        "height": data.height,
                        "weight": data.weight,
                        "mobile": data.mobile,
                        "age": data.age,
                        "mzh": data.mzh
                    };
                }
                const result = await API.getResult({
                    userId: loginInfo.uid,
                    taskId: this.taskID,
                    phone: loginInfo.mobile
                })
                // 保存用户信息
                const accountInfoModel = new AccountInfoModel({
                    userInfo,
                    result
                }, loginInfo.mobile)
                this.$store.commit('saveAccountModel', accountInfoModel)
                // 界面跳转
                NavigationTool.appNavigate()
            } catch (error) {
                NavigationTool.navigateToError(error)
            }

        }
    },
}
</script>
<style scoped lang='scss'></style>